import * as React from 'react'
import { cn } from '@/lib/utils'

/* Card: a raised surface used for hierarchy — not applied to every group. */
function Card({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      data-slot="card"
      className={cn('rounded-md border border-line bg-surface', className)}
      {...props}
    />
  )
}

function CardHeader({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn('flex flex-col gap-1 border-b border-line px-5 py-4', className)}
      {...props}
    />
  )
}

/* `level` keeps the outline unbroken: 2 for a card directly under the page's h1, 3 (default) under a section heading. */
function CardTitle({ className, level = 3, ...props }: React.HTMLAttributes<HTMLHeadingElement> & { level?: 2 | 3 }) {
  const Heading = level === 2 ? 'h2' : 'h3'
  return <Heading className={cn('text-lg text-fg-strong', className)} {...props} />
}

function CardDescription({ className, ...props }: React.HTMLAttributes<HTMLParagraphElement>) {
  return <p className={cn('text-sm text-fg-muted', className)} {...props} />
}

function CardContent({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('px-5 py-4', className)} {...props} />
}

export { Card, CardHeader, CardTitle, CardDescription, CardContent }
